/**
 * Configuration for parser detection
 */
interface ParserConfig {
  readonly maxLinesToCheck: number;
  readonly spaceIndentSize: number;
  readonly maxInputSize: number;
}

/**
 * Constants for parser configuration
 */
export const PARSER_CONFIG: Readonly<ParserConfig> = {
  maxLinesToCheck: 10,
  spaceIndentSize: 2,
  maxInputSize: 1024 * 1024 // 1MB default limit
};

/**
 * Regular expressions used across parsers
 */
export const REGEX_PATTERNS = {
  numberedList: /^\s*\d+\./,
  bulletList: /^\s*[•\-*]\s/,
  bulletListMultiline: /^\s*[•\-*]\s/m,
  bulletListInline: /[•\-*]\s/,
  htmlList: /<(ul|ol|li)\b[^>]*>/i,
  htmlNestedList: /<(ul|ol)\b[^>]*>/i,
  whitespace: /^\s+/,
  htmlTag: /<[^>]*>/g,
  htmlComment: /<!--[\s\S]*?-->/g,
  cdataSection: /<!\[CDATA\[[\s\S]*?\]\]>/g,
  whitespaceNormalize: /\s+/g,
  carriageReturn: /\r/g,
  numberedListPrefix: /^\d+\.\s*/,
  bulletListPrefix: /^[•\-*]\s*/
};

/**
 * HTML entities mapping
 */
export const HTML_ENTITIES = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"'
};
